package com.wintermar.inspection.feature.presentation.inspection.complete.widget.page_info

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun PageInfo(
    pages: List<String>,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClick: (page: String) -> Unit
) {
    LazyColumn(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
    ) {
        items(pages) {
            TextBodySmall(
                text = it,
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable {
                        onClick(it)
                    }
                    .padding(
                        vertical = dimension.spacing.space2,
                        horizontal = dimension.spacing.space5
                    )
            )
            HorizontalDivider(
                modifier = Modifier.fillMaxWidth(),
                color = color.border.subtle
            )
        }
    }
}
